module.exports = __webpack_public_path__ + "static/media/wtfooterlogo.fbdf87d1.png";